import { useTranslations } from 'next-intl';
import React from 'react';

import NoContentsIcon from '@/shared/ui/svgs/noContentsIcon.svg';

export default function PcNoContents() {
  const t = useTranslations('customer');
  return (
    <div className="w-full h-full flex justify-center items-center">
      <div className="flex flex-col gap-4 items-center">
        <NoContentsIcon />
        <p className="text-[#AAAAAA] font-medium text-locale-20 leading-[32px] text-center">
          {t('empty_message')}
        </p>
      </div>
    </div>
  );
}
